import React, { memo } from 'react';
import { Text, TextTypography } from '@wix/wix-ui-tpa/cssVars';
import { useSettings, useStyles } from '@wix/tpa-settings/react';
import { ISettingsContextValue } from '@wix/tpa-settings';
import { st, classes } from '../Widget.st.css';
import { st as headerStyle, classes as headerClasses } from './header.st.css';
import { CategoriesPosition } from '../../../../enums';
import { DATA_HOOKS } from '../../../../constants/dataHooksElements';
import settingsParams from '../../settingsParams';
import stylesParams from '../../stylesParams';
import { useLayoutType } from '../../../../hooks/useLayoutType';

export interface HeaderWrapperProps {
  isEditor3: boolean;
}

const HeaderWrapper = memo(function HeaderWrapper({
  isEditor3,
}: HeaderWrapperProps) {
  const settings: ISettingsContextValue = useSettings();
  const styles = useStyles();
  const { categoriesPosition } = useLayoutType(isEditor3);
  const isTopCategoriesPosition = categoriesPosition === CategoriesPosition.TOP;
  const { text, show = true, alignment } = settings.get(settingsParams.title);
  const titleText = isEditor3 ? settings.get?.(settingsParams.titleText) : text;
  const showTitleStyleParam = styles.get?.(stylesParams.showTitle) ?? true;
  const showTitle = show && showTitleStyleParam;
  const headerStyleParam = styles.get?.(stylesParams.headerTextFont);

  if (!showTitle) {
    return null;
  }
  return (
    <div
      className={st(classes.title, {
        isTopCategoriesPosition,
        alignment,
      })}
    >
      <Text
        tagName={
          (headerStyleParam?.htmlTag as keyof JSX.IntrinsicElements) ?? 'h1'
        }
        className={headerStyle(headerClasses.title)}
        typography={TextTypography.largeTitle}
        data-hook={DATA_HOOKS.WIDGET_HEADER_TITLE_TEXT}
      >
        {titleText}
      </Text>
    </div>
  );
});

export default HeaderWrapper;
